// Utils
import { createNamespace } from '../utils';
import { inherit } from '../utils/functional';
import VanEmptyCol from '../emptycol';
// import Text from '../text';
const [createComponent, bem] = createNamespace('divider');
function Divider(h, props, slots, ctx) {
    const designer = ctx.parent?.$env?.VUE_APP_DESIGNER;
    return (<div role="separator" style={{ borderColor: props.borderColor }} class={bem({
        dashed: props.dashed !== 'a',
        hairline: props.hairline,
        [`content-${props.contentPosition}`]: designer || (props.title || (slots.default && slots.default())),
    })} {...inherit(ctx, true)}>
      {props.title ? (<span vusion-slot-name-edit="title">{props.title}</span>) : slots.default ? (slots.default()) : (designer && (<span vusion-slot-name="default">
            <VanEmptyCol></VanEmptyCol>
          </span>))}
    </div>);
}
Divider.props = {
    dashed: {
        type: String,
        default: 'a',
    },
    hairline: {
        type: Boolean,
        default: true,
    },
    contentPosition: {
        type: String,
        default: 'center',
    },
    title: {
        type: String,
    },
};
export default createComponent(Divider);
